import Vue from 'vue';
import company from '@/assets/default/company.png';
import boy from '@/assets/default/boy40.png';
import girl from '@/assets/default/girl40.png';
import defaultYearReportAvatar from '@/assets/yearReport/defaultAvatar.png';
import defaultCustomerAvatar from '@/assets/default/customer.png';


//公司图片错误
Vue.directive('img-error-company', async function (el) {
    let imgURL = el.src;//获取图片地址
    if (imgURL) {
        let exist = await imageIsExist(imgURL);
        if (!exist) { //如果不存在
            
            el.setAttribute('src', company);
        } 
    }
})

//年度报告图片错误
Vue.directive('img-error-year', async function (el) {
    let imgURL = el.src;//获取图片地址
    if (imgURL) {
        let exist = await imageIsExist(imgURL);
        if (!exist) { //如果不存在
            
            el.setAttribute('src', defaultYearReportAvatar);
        } 
    }
})

// 客户图片
Vue.directive('img-error-customer', async function (el) {
    let imgURL = el.src;//获取图片地址
    if (imgURL) {
        let exist = await imageIsExist(imgURL);
        if (!exist) { //如果不存在
            
            el.setAttribute('src', defaultCustomerAvatar);
        } 
    }
})

//用户图片错误 v-img-error-user="1"
Vue.directive('img-error-user', async function (el , gender) {
    let imgURL = el.src;//获取图片地址

    if (imgURL) {
        let exist = await imageIsExist(imgURL);
        if (!exist) { //如果不存在
            if(gender == 1){
                el.setAttribute('src', boy);
            }else{
                el.setAttribute('src', girl);
            }
        } 
    }
})

/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function(url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true){
                resolve(true);
                img = null;
            }
        }
        img.onerror = function () {
            resolve(false);
            img = null;
        }
        img.src = url;
    })
}